import { SelectOptions } from '@/components/small-select';

export const PAGE_TYPE_PATTERNS = {
  HOMEPAGE: `/`,
  CART: `.*/cart`,
  CHECKOUT: `.*/checkout`,
  COLLECTION: `.*/collections/.*`,
  PRODUCT: `.*/products/.*`,
} as const;

export const PAGE_TYPE_LABELS = {
  HOMEPAGE: `Homepage`,
  CART: `Cart`,
  CHECKOUT: `Checkout`,
  COLLECTION: `Collection`,
  PRODUCT: `Product`,
} as const;

export const getPageTypeOptions = (
  includeCheckout = false,
): SelectOptions[] => {
  const baseOptions: SelectOptions[] = [
    { key: PAGE_TYPE_PATTERNS.HOMEPAGE, value: PAGE_TYPE_LABELS.HOMEPAGE },
    { key: PAGE_TYPE_PATTERNS.CART, value: PAGE_TYPE_LABELS.CART },
  ];

  if (includeCheckout) {
    baseOptions.push({
      key: PAGE_TYPE_PATTERNS.CHECKOUT,
      value: PAGE_TYPE_LABELS.CHECKOUT,
    });
  }

  baseOptions.push(
    { key: PAGE_TYPE_PATTERNS.COLLECTION, value: PAGE_TYPE_LABELS.COLLECTION },
    { key: PAGE_TYPE_PATTERNS.PRODUCT, value: PAGE_TYPE_LABELS.PRODUCT },
  );

  return baseOptions;
};
